"use client";

import { useEffect } from "react";
import { useToast } from "@/components/portal/Toast";
import { readSession } from "@/lib/portal/session";

/** Staff accounts cannot enquire or enrol - the same notice every enquiry entry point shows. */
export const STAFF_ENQUIRY_NOTICE = { title: "Students only", message: "Staff accounts can't enrol in courses." };

export function isStaffSession(): boolean {
  const session = readSession();
  return !!session && session.role !== "student";
}

/**
 * Stops any "Enquiry Now" / "Enquire Now" link (anything pointing at /contact?tab=enquiry) for a signed-in staff member
 * and shows the notice instead of opening the form.
 */
export function StaffEnquiryGuard() {
  const toast = useToast();

  useEffect(() => {
    function onClick(e: MouseEvent) {
      if (e.defaultPrevented || e.button !== 0) return;
      const link = (e.target as Element | null)?.closest?.("a[href]") as HTMLAnchorElement | null;
      if (!link) return;
      const href = link.getAttribute("href") ?? "";
      if (!/^\/contact\?(?:.*&)?tab=enquiry(?:&|#|$)/.test(href)) return;
      if (!isStaffSession()) return;
      e.preventDefault();
      e.stopPropagation();
      toast.info(STAFF_ENQUIRY_NOTICE.title, STAFF_ENQUIRY_NOTICE.message);
    }
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, [toast]);

  return null;
}
